module.exports = __webpack_public_path__ + "static/assets/f8d8b9d9f1aa45900b786980418219b1.mp3";